<div *ngIf="urlMetaData?.images[0]">
    <div class="row border-rounded">
      <img [src]="urlMetaData?.images[0] || ''" alt="site image" class="px-3 preview-img" min-width="100%"
        min-height="100%" max-width="100%" max-height="350px" width="100%" object-fit="cover">
      <div class="col py-1 mx-2">
        <a href="{{url}}" target="blank_"><span class="font-weight-bold">{{urlMetaData?.title}}</span></a>
        <p class="preview-lines">
          {{urlMetaData?.description}}
        </p>
        <i class="fas fa-link"></i><a href="{{url}}" target="blank_"><span
            class="preview-link pl-1">{{urlMetaData?.name}}</span></a>
      </div>
    </div>
</div>